import React, { useState, useEffect } from 'react';
import configData from "../../config.json";
import ApiServices from '../../services/ApiServices';
import { useHistory } from 'react-router-dom';

export const Collections = ({ onOpenCollection, isMyCollections, changedUserHasCollections }) => {
    const [collections, setCollections] = useState([]);
    const [user, setUser] = useState();
    const history = useHistory();

    useEffect(() => {
        let isMounted = true;

        const loadData = async () => {
            const loggedInUser = localStorage.getItem("user");
            let currentUser = null;

            if (loggedInUser) {
                currentUser = JSON.parse(loggedInUser);
                if (isMounted) setUser(currentUser);
            }

            const data = await ApiServices.getCollections(isMyCollections, currentUser);

            if (!isMounted) return;

            if (changedUserHasCollections) {
                changedUserHasCollections(data && data.length > 0);
            }

            setCollections(data);
        };

        loadData();

        return () => {
            isMounted = false;
        };
    }, []);

  

    function onCollectionClick(collection) {
        if (isMyCollections)
            history.push('/collection/' + collection.collectionId);
        else
            onOpenCollection(collection)
    }

    return (
        <div>{
            collections.map((collection) => (
                <div key={collection.collectionId} className="collection" onClick={() => onCollectionClick(collection)}>
                    <b>{collection.name}</b>
                    <img src={configData.BLOB_COLLECTION_URL + collection.imageFile} />
                </div>
            ))
        }</div>
    );
}

export default Collections;
